<div ng2FileDrop [uploader]="uploader" class="upl-file {{ status }}" (fileOver)="fileOverBase($event)" [ngClass]="{ 'upl-file-drop': hasDropHover }">
	<div class="upl-progress upl-progress-{{ progress }}">
		<form (click)="fileInput.click()">
			<input type="file" ng2FileSelect class="d-none" [uploader]="uploader" #fileInput multiple />
			<ng-content></ng-content>
		</form>
	</div>
</div>